var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1946_786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.87372 11.7466C7.8943 11.7979 7.93008 11.8417 7.97625 11.8721C8.02242 11.9024 8.07677 11.9179 8.13201 11.9165C8.18726 11.9151 8.24074 11.8968 8.2853 11.8641C8.32985 11.8314 8.36334 11.7859 8.38127 11.7336L11.9021 1.44197C11.9194 1.39397 11.9227 1.34203 11.9116 1.29223C11.9005 1.24242 11.8755 1.19681 11.8394 1.16072C11.8033 1.12464 11.7577 1.09958 11.7079 1.08847C11.6581 1.07737 11.6061 1.08067 11.5581 1.09801L1.26647 4.61884C1.2142 4.63677 1.16866 4.67026 1.13597 4.71481C1.10328 4.75936 1.085 4.81285 1.08358 4.8681C1.08217 4.92334 1.09769 4.97769 1.12806 5.02386C1.15842 5.07003 1.20219 5.10581 1.25347 5.12638L5.54889 6.84888C5.68468 6.90325 5.80805 6.98455 5.91157 7.08788C6.01509 7.19122 6.09661 7.31444 6.15122 7.45013L7.87372 11.7466Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8377 1.16296L5.91187 7.08826",
    stroke: "#9CA3AF",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1946_786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendNewIcon);
export default __webpack_public_path__ + "static/media/SendNewIcon.89eefab69b8101b6a8b1af39e776fb64.svg";
export { ForwardRef as ReactComponent };